import React from "react"

import {
  BaseTextIcon,
  CodeIcon,
  Heading1Icon,
  Heading2Icon,
  Heading3Icon,
  QuoteIcon,
} from "@editor/theme/editorIcons"

export const blockTypeToBlockName = {
  paragraph: {
    value: "Обычный",
    icon: <BaseTextIcon />,
  },
  h1: {
    value: "Заголовок 1",
    icon: <Heading1Icon />,
  },
  h2: {
    value: "Заголовок 2",
    icon: <Heading2Icon />,
  },
  h3: {
    value: "Заголовок 3",
    icon: <Heading3Icon />,
  },
  quote: {
    value: "Цитата",
    icon: <QuoteIcon />,
  },
  code: {
    value: "Блок кода",
    icon: <CodeIcon />,
  },
}
